module.exports = __webpack_public_path__ + "static/fonts/AkkuratPro-Bold.33f1e7c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AkkuratPro-Bold.woff
// module id = REYW
// module chunks = 1